import JsonLd from '@/src/components/elements/JsonLd'
import { Breadcrumb } from '@/src/components/flch/breadcrumbs'

function normalizeUrl(url: string) {
  return url.replace(/\/$/, '')
}

export default function BreadcrumbListJsonLd({
  breadcrumbs,
  fullUrl,
}: {
  breadcrumbs: Breadcrumb[]
  fullUrl?: string | null
}) {
  if (!fullUrl) {
    return null
  }

  const items = breadcrumbs.map((breadcrumb) => ({
    name: breadcrumb.name,
    url: breadcrumb.href
      ? new URL(breadcrumb.href, fullUrl).toString()
      : fullUrl,
  }))

  if (
    items.length < 2 ||
    normalizeUrl(items[items.length - 1].url) === normalizeUrl(items[0].url)
  ) {
    return null
  }

  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
      }}
    />
  )
}
